<template>
  <i class="fa fa-fw fa-globe"></i>
</template>

<script>
export default {
  name: 'Webhook',
};
</script>

<style scoped>
.fa-globe {
  color: #cf2941;
}
</style>



// WEBPACK FOOTER //
// WebhookIcon.vue?378c293a